import { render, staticRenderFns } from "./resultModal.vue?vue&type=template&id=1a7b4777&scoped=true&"
import script from "./resultModal.vue?vue&type=script&lang=ts&"
export * from "./resultModal.vue?vue&type=script&lang=ts&"
import style0 from "./resultModal.vue?vue&type=style&index=0&id=1a7b4777&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b4777",
  null
  
)

export default component.exports